// extracted by mini-css-extract-plugin
export var button = "_js-2";
export var card = "_js-0";
export var closeButtonContainer = "_js-3";
export var iconContainer = "_js-1";